import type { JobItemResultVisibleJob } from '../../helpers';

export type ItemWithBanners =
  | JobItemResultVisibleJob
  | 'ProJobsUpsellBanner'
  | 'Ad';

type GetItemBannerProps = {
  showProJobsUpsellBanner?: boolean;
};

export const getItemsWithBanner = (
  jobs: JobItemResultVisibleJob[],
  { showProJobsUpsellBanner }: GetItemBannerProps = {}
): ItemWithBanners[] => {
  const proJobsBannerIndex = 2;
  const adIndex = showProJobsUpsellBanner ? 4 : 5;

  const firstPart = jobs.slice(0, proJobsBannerIndex);
  const secondPart = jobs.slice(proJobsBannerIndex, adIndex);
  const lastPart = jobs.slice(adIndex);

  const projobsBanner = showProJobsUpsellBanner
    ? ['ProJobsUpsellBanner' as const]
    : [];
  const ad = ['Ad' as const];

  return [...firstPart, ...projobsBanner, ...secondPart, ...ad, ...lastPart];
};
